import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import TextField from '../../elements/form/TextField';
import { clearCreatedDepartment, createDepartment } from '../../../store/actions/departmentActions';
import TextareaField from '../../elements/form/TextareaField';
import RadioGroup from '../../elements/form/RadioGroup';

const NewDepartment = ({closeFunction, reload}) => {
    const dispatch = useDispatch()
    const departmentsSelector = useSelector(state => state.departments)

    const [departmentPayload, setDepartmentPayload] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        if(departmentsSelector.createdDepartment !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'New department created successfully!'
            })
            dispatch(clearCreatedDepartment())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departmentsSelector.createdDepartment, dispatch, closeFunction]);

    const validateForm = () => {
        let errors = {}
        if(!departmentPayload.name || departmentPayload.name === '') {
            errors.name = true
        }
        if(!departmentPayload.type || departmentPayload.type === '') {
            errors.type = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushDepartment = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(createDepartment(departmentPayload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    const departmentTypes = [
        {
            label: 'Academic',
            value: 'academic'
        },
        {
            label: 'Non-academic',
            value: 'non-academic'
        },
    ]

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>Provide the following information to create a new academic session</p>
            </div>
            <div className='mt-4'>
                <TextField
                    inputLabel="Department name" 
                    fieldId="fee-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={departmentPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setDepartmentPayload({...departmentPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="status-note" 
                    inputType="text" 
                    requiredField={false}
                    preloadValue={departmentPayload.description || ''}
                    hasError={false} 
                    maxLength={300}
                    returnFieldValue={(value)=>{setDepartmentPayload({...departmentPayload, ...{description: value}})}}
                />
                {departmentPayload?.description?.length === 300 &&<p className='text-red-600 text-xs mt-2'>Please keep the description less than 300 characters</p>}
            </div>

            <div className='mt-4'>
                <RadioGroup 
                    items={departmentTypes} 
                    inline={true}
                    preSelectedIndex={departmentTypes.findIndex(item => item.value === departmentPayload.type)}
                    inputLabel={'Department Type'}
                    requiredField={true}
                    returnSelected={(value) => {setDepartmentPayload({...departmentPayload, ...{type: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>

            {/* <div className='my-2 w-full'>
                <DateField
                    inputLabel="Start Date" 
                    fieldId="start-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(sessionPayload.startDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.startDate} 
                    returnFieldValue={(value)=>{
                        const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                        setSessionPayload({...sessionPayload, ...{startDate: formattedDate}})
                    }}
                />
            </div>

            <div className='my-2 w-full'>
                <DateField
                    inputLabel="End Date" 
                    fieldId="end-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(sessionPayload.endDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.endDate} 
                    returnFieldValue={(value)=>{
                        const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                        setSessionPayload({...sessionPayload, ...{endDate: formattedDate}})
                    }}
                />
            </div> */}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create department`}
                    buttonAction={()=>{pushDepartment()}}
                    processing={departmentsSelector.creatingDepartment}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewDepartment